<!-- Section principale ouverte ci-dessous -->
<section class="page">
  <header class="page-header">
    <h2>Adresses</h2>
    <p class="subtitle">Gérez les adresses de livraison et de facturation associées à chaque client.</p>
  </header>

  @if (success) {
    <div class="success">{{ success }}</div>
  }
  @if (error) {
    <div class="error">{{ error }}</div>
  }

  <form class="panel" (ngSubmit)="createOrUpdate()">
    <h3>{{ pageTitle }}</h3>

    @if (isEditMode) {
      <label for="selected_adresse">Adresse à modifier *</label>
      <select
        id="selected_adresse"
        name="selected_adresse"
        [ngModel]="selectedId"
        (ngModelChange)="onSelectedAdresseChange($event)"
        required
      >
        <option value="">-- sélectionner --</option>
        @for (adresse of adresses; track adresse.id) {
          <option [value]="adresse.id">{{ getAdresseOptionLabel(adresse) }}</option>
        }
      </select>
    }

    <label for="client_id">Client *</label>
    
    <select id="client_id" name="client_id" [(ngModel)]="form.client_id" required>
      <option value="">-- sélectionner --</option>
      @for (client of clients; track client.id) {
        <option [value]="client.id">{{ client.identifiant }}</option>
      }
    </select>
    <label for="nom">Nom</label>
    <input id="nom" name="nom" [(ngModel)]="form.nom" maxlength="100" />

    <label for="prenom">Prénom</label>
    <input id="prenom" name="prenom" [(ngModel)]="form.prenom" maxlength="100" />

    <label for="service">Service</label>
    <input id="service" name="service" [(ngModel)]="form.service" maxlength="100" />

    <label for="raison_sociale">Raison sociale</label>
    <input id="raison_sociale" name="raison_sociale" [(ngModel)]="form.raison_sociale" maxlength="100" />

    <label for="email">Email</label>
    <input id="email" name="email" [(ngModel)]="form.email" maxlength="100" />

    <label for="telephone">Téléphone</label>
    <input id="telephone" name="telephone" [(ngModel)]="form.telephone" maxlength="20" />

    <label for="adresse">Adresse *</label>
    <input id="adresse" name="adresse" [(ngModel)]="form.adresse" maxlength="255" required />

    <label for="code_postal">Code postal *</label>
    <input id="code_postal" name="code_postal" [(ngModel)]="form.code_postal" maxlength="10" required />

    <label for="ville">Ville *</label>
    <input id="ville" name="ville" [(ngModel)]="form.ville" maxlength="100" required />

    <label for="pays">Pays *</label>
    <input id="pays" name="pays" [(ngModel)]="form.pays" maxlength="100" required />

    <label for="type_adresse">Type *</label>
    <select id="type_adresse" name="type_adresse" [(ngModel)]="form.type_adresse" required>
      <option value="livraison">Livraison</option>
      <option value="facturation">Facturation</option>
      <option value="livraison et facturation">Livraison et facturation</option>
    </select>

    

    <div class="actions">
      <button type="submit" [disabled]="loading">{{ isEditMode ? 'Enregistrer' : 'Créer' }}</button>
      <button type="button" (click)="clearForm()">Annuler</button>
    </div>
  </form>

  </section>